import { type TenantSettings } from '@repo/tenancy/types';
import React from 'react';
import { type TranslationType } from '@/lib/types';

interface FooterLinkItem {
  name?: string;
  Icon?: React.FC;
  href: string;
}

interface FooterLink {
  id: string;
  title: string;
  items: FooterLinkItem[];
  className?: string;
}

export const getFooterLinksItems = (t: TranslationType, _tenantSettings: TenantSettings) => {
  return [
    {
      id: 'casino',
      title: t('casino'),
      items: [
        {
          name: t('casino-home'),
          href: '/casino',
        },
        {
          name: t('slots'),
          href: '/casino/slots',
        },
        {
          name: t('live-casino'),
          href: '/casino/live',
        },
        {
          name: t('new-releases'),
          href: '/casino/new',
        },
        {
          name: t('plinko'),
          href: '/casino/plinko',
        },
        {
          name: t('crash-game'),
          href: '/casino/crash',
        },
        {
          name: t('blackjack'),
          href: '/casino/blackjack',
        },
        {
          name: t('roulette'),
          href: '/casino/roulette',
        },
        {
          name: t('baccarat'),
          href: '/casino/baccarat',
        },
      ],
    },
    {
      id: 'support-legal',
      title: t('support-legal'),
      items: [
        {
          name: t('help-center'),
          href: '/static/help',
        },
        {
          name: t('privacy-policy'),
          href: '/static/privacy-policy',
        },
        {
          name: t('terms-and-conditions'),
          href: '/static/terms-and-conditions',
        },
        {
          name: t('referral-program-terms-of-service'),
          href: '/static/referral-terms-and-conditions',
        },
        {
          name: t('responsible-gambling'),
          href: '/static/responsible-gambling',
        },
      ],
    },
    {
      id: 'promo',
      title: t('promo'),
      items: [
        {
          name: t('refer-a-friend'),
          href: '/account/affiliates',
        },
      ],
    },
  ] as FooterLink[];
};
